import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useEvents } from "components/events/hooks/useEvents";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";

export default function ViewEvent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadEventsById } = useEvents();

  const [data, setData] = useState(null);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
  loadEventsById(id).then(setData);
}, [id]);

  if (!data) return <p className="p-6">Loading...</p>;

  const event = data.event || data;
  const exhibitors = data.exhibitors || [];

  return (
    <div className="p-6 space-y-8">

      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Event Details</h1>
        <button
          onClick={() => navigate(-1)}
          className="rounded-xl border px-4 py-2"
        >
          Back
        </button>
      </div>

      <Card title="Event Information">
        <Info label="Event Name" value={event.event_name} />
        <Info label="Status" value={event.status} />
        <Info label="Location" value={event.location} />
        <Info
          label="From Date"
          value={event.event_dates?.[0]?.from_date
            ? new Date(event.event_dates[0].from_date).toLocaleString()
            : "-"}
        />

        <Info
          label="To Date"
          value={event.event_dates?.[0]?.to_date
            ? new Date(event.event_dates[0].to_date).toLocaleString()
            : "-"}
        />

        <Info
          label="Description"
          value={event.description}
        />
      </Card>

      <Card title="Organizer Information">
        <Info
          label="Company Name"
          value={event.company_id?.companyName}
        />
      </Card>

      {event.eventImage?.length > 0 && (
        <Card title="Event Images">
          <div className="flex flex-wrap gap-4 col-span-2">
            {event.eventImage.map((img, index) => (
              <img
                key={index}
                src={getImageUrl(img)}
                alt="Event"
                className="h-24 w-auto rounded-xl border cursor-pointer object-contain"
                onClick={() => {
                  setActiveImage(img);
                  setViewerOpen(true);
                }}
              />
            ))}
          </div>
          <ImageViewer
            open={viewerOpen}
            onClose={() => setViewerOpen(false)}
            src={getImageUrl(activeImage)}
          />
        </Card>
      )}

      {event.eventVideo?.length > 0 && (
        <Card title="Event Videos">
          <div className="flex flex-wrap gap-4 col-span-2">
            {event.eventVideo.map((video, index) => (
              <video
                key={index}
                src={getImageUrl(video)}
                controls
                className="h-40 rounded-xl border"
              />
            ))}
          </div>
        </Card>
      )}



      {/* {event.default_media && (
        <Card title="Default Media">
          <div className="col-span-2">
            {event.default_media.type === "image" ? (
              <img
                src={getImageUrl(event.default_media.value)}
                alt="Default"
                className="h-48 rounded-xl border cursor-pointer"
                onClick={() => {
                  setActiveImage(event.default_media.value);
                  setViewerOpen(true);
                }}
              />
            ) : (
              <video
                src={getImageUrl(event.default_media.value)}
                controls
                className="h-48 rounded-xl border"
              />
            )}
          </div>
        </Card>
      )} */}


      <Card title="Exhibitors">
        {exhibitors.length ? (
          <ul className="space-y-2 col-span-2">
            {exhibitors.map((e) => (
              <li
                key={e._id}
                className="rounded-lg border p-3 flex justify-between"
              >
                <div>
                  <p className="font-medium">
                    {e.exhibitor_id?.title || "-"}
                  </p>
                  <p className="text-sm text-gray-500">
                    Pavilion: {e.pavilion_id?.pavilion_name || "-"}
                  </p>
                </div>
                <div className="text-sm">
                  Stall No: <b>{e.stall_no || "-"}</b>
                </div>
                <div className="text-sm">
                  Floor No: <b>{e.floor_no || "-"}</b>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500 col-span-2">
            No exhibitors assigned
          </p>
        )}
      </Card>
    </div>
  );
}


function Card({ title, children }) {
  return (
    <div className="rounded-[20px] bg-white p-6 shadow-3xl">
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );
}
